import { apiClient } from '@/lib/apiClient';
import type { AlcadaDto, CriarAlcadaRequest, AtualizarAlcadaRequest } from '../types';

const BASE = '/api/compras/alcadas';

export const alcadaService = {
  getAll: () => apiClient.get<AlcadaDto[]>(BASE).then(r => r.data),

  getById: (id: number) => apiClient.get<AlcadaDto>(`${BASE}/${id}`).then(r => r.data),

  create: (data: CriarAlcadaRequest) =>
    apiClient.post<AlcadaDto>(BASE, data).then(r => r.data),

  update: (id: number, data: AtualizarAlcadaRequest) =>
    apiClient.put<AlcadaDto>(`${BASE}/${id}`, data).then(r => r.data),

  remove: (id: number) => apiClient.delete(`${BASE}/${id}`),
};
